/** The project protocol's overlays, mounted once in the shell so any page can open them. */
import { ActionDialogHost } from './ActionDialog.tsx';
import { DispatchDialogHost } from './DispatchDialog.tsx';
import { ProblemDrawerHost } from './Problems.tsx';
import { ProjectHealthDrawerHost } from './ProjectHealthDrawer.tsx';

export function ProjectHealthHosts() {
  return (
    <>
      <ProblemDrawerHost />
      <ProjectHealthDrawerHost />
      <ActionDialogHost />
      <DispatchDialogHost />
    </>
  );
}
